import { interviewKitConstants } from "../../_constants";

const initialState = {};

// mentor profile
export const get_interview_kit_by_id_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS:
    case interviewKitConstants.UPDATE_INTERVIEW_KIT_ACTION_SUCCESS:
    case interviewKitConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewKitData: action.payload,
        interviewCreated: false,
      };

    case interviewKitConstants.CREATE_INTERVIEW_KIT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewKitData: action.payload,
        interviewCreated: true,
      };
    case interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_interview_kit_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allInterviewKitsData: action.payload,
      };
    case interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_published__interview_kit_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allPublishedInterviewKitsData: action.payload,
      };
    case interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//get assigned interview kit
export const get_assigned_interview_kit_job_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
    case interviewKitConstants.ASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
    case interviewKitConstants.UNASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewKitAssignedData: action.payload,
      };
    case interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//get assigned interview kit
export const get_submitted_candidates_list_interview_kit_mentor_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS:
      return {
        type: "alert-success",
        submittedCandidatesInterviewListData: action.payload,
      };
    case interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//get assigned interview kit
export const assessment_kit_question_skill_rating_mentor_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
    case interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
    case interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
    case interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
    case interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assessmentKitQuestionRatingData: action.payload,
      };
    case interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
    case interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
    case interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


// get all remarklist reducer
export const  get_interview_kit_remarklist_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        RemarkData: action.payload,
      };
    case interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// add remark reducer
export const  add_remark_to_interview_kit_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        AddedRemark: action.payload,
      };
    case interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// add remark reducer
export const  update_remark_to_interview_kit_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        updatedRemarkData: action.payload,
      };
    case interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};